import { TypedDocumentNode, gql } from "@apollo/client";

type TestimonialsData = {
  testimonials: TestimonialInterface[];
};

export const GET_TESTIMONIALS: TypedDocumentNode<TestimonialsData> = gql`
  query GetTestimonials {
    testimonials {
      id
      userName
      jobTitle
      companyName
      fiveStarRating
      avatar
      avatar_img
      comments
      facebookUrl
      linkedinUrl
      twitterUrl
      instagramUrl
      category {
        name
      }
      service {
        name
        shortName
      }
    }
  }
`;
